import { makeStyles } from '@material-ui/core';

export const InputStyles = makeStyles({
    root: {
        width: '100%',
    },
});
